import { render } from "./CareAssignmentSheetReport.vue?vue&type=template&id=cf1fbbd6&scoped=true&ts=true"
import script from "./CareAssignmentSheetReport.vue?vue&type=script&lang=ts"
export * from "./CareAssignmentSheetReport.vue?vue&type=script&lang=ts"

import "./CareAssignmentSheetReport.vue?vue&type=style&index=0&id=cf1fbbd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1fbbd6"]])

export default __exports__